import {CloseBurger, OpenBurger} from "../../animations/burgerMenu/burgerAnimation";
import {fixedScroll} from "../../modules/disablescroll";

export default function responsiveNavbar() {
    const $navbar = {
        container: $('.c-navbar__responsive'),
        burger: $('.c-navbar__responsive--burger, .c-navbar__responsive--burger a'),
        menu: $('.c-navbar__responsive--menu'),
        items: $('.c-navbar__responsive--menu li'),
        class: 'js-isActive'
    }

    if ($navbar.container.length > 0) {
        $navbar.burger.click(function () {
            if (!$navbar.menu.hasClass($navbar.class)) {

                fixedScroll(true);
                $('.c-navbar__responsive--burger').addClass($navbar.class);
                $navbar.menu.addClass($navbar.class);
                OpenBurger();
                TweenMax.to($navbar.menu, .3, {scaleY: 1, ease: Power3.easeOut});
                TweenMax.to($navbar.items, 1, {opacity: 1, delay: .2});

            } else {
                setTimeout(function () {

                    fixedScroll(false);
                    $('.c-navbar__responsive--burger').removeClass($navbar.class);
                    $navbar.menu.removeClass($navbar.class);
                    TweenMax.to($navbar.items, .5, {opacity: 0});
                    TweenMax.to($navbar.menu, .3, {scaleY: 0, ease: Power3.easeOut, delay: .8});
                    CloseBurger();

                }, 100);
            }
        });
    }
}
